import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/arnauld-quadrature.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';
import Mobile from '../images/arnauld-quadrature.png'; /*Change image path*/

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {          /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>      
        Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LBrF 20 Bl. 165r<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 23 October 1683<br /><br />
		Translated from the French<br /><br />{isMobile ? '' : <hr className="centered-hr" />}
		<Link to={pdf} target="_blank">View this translation in PDF format (405k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Extract From a Letter From Mr. Arnauld to Landgrave Ernst, on Leibniz's Quadrature of the Circle </title> {/*Change title*/}
            <meta name="description" content="An English translation of EXTRACT FROM A LETTER FROM MR. ARNAULD TO LANDGRAVE ERNST, ON LEIBNIZ'S QUADRATURE OF THE CIRCLE by Antoine Arnauld, from 23 October 1683" />  {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>EXTRACT FROM A LETTER FROM MR. ARNAULD TO LANDGRAVE ERNST, ON LEIBNIZ'S QUADRATURE OF THE CIRCLE</h2> {/*Change title*/}
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <><img src={Mobile} width="100%"/></> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;